import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as R from 'ramda';
import $ from 'jquery';

import { AddPartner } from './../../_common/AddPartner';

export const DetailNav = ({ partner, isLoading }) => {

	const [selectedPartner, setSelectedPartner] = useState(partner);
	useEffect(() => {
		setSelectedPartner(partner);
	}, [partner]);

	// const initValue = !R.isNil(partner) ? partner : {
	// 	name: 'Partenaires paramètres'
	// }
	// const [partnerInfo, setPartnerInfo] = useState(initValue);

	// useEffect(() => {
	// 	if (R.isNil(partner)) {
	// 		setPartnerInfo(initValue);
	// 	} else {
	// 		setPartnerInfo({ ...partner });
	// 	}
	// }, [partner]);

	// useEffect(() => {
	// 	$('[data-toggle="tooltip"]').tooltip();
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, []);
	return (
		<nav className="nav py-3 pt-lg-5">
			<div className="container-fluid">
				<div className="flex-row align-items-center justify-content-md-between">
					<Link to="/backoffice/partners" className="h6 font-weight-regular my-auto text-gray mw-min mw-md-auto">
						<i className="eva eva-corner-up-left-outline fs-sm align-middle mr-2"></i>
						<h1 className="fs-inherit lh-1 d-inline-block align-middle my-auto">Voir tout les <span className="font-weight-semi">Partenaires</span></h1>
					</Link>
					<div className="flex-row ml-auto">
						<button type="button" className="btn btn-faded btn-row px-3 px-lg-sm mr-md-0" data-toggle="modal" data-target="#AddPartner">
							<i className="eva eva-settings-2-outline btn-icon bg-none my-auto fs-root lh-1 align-middle mr-xs" ></i>
							<span className="btn-text align-middle o-60">{partner.name}</span>
						</button>
					</div>
				</div>
			</div>
			<AddPartner isLoading={isLoading} partner={selectedPartner} />
		</nav>
	);
};